import axios from "axios";
import {Group, GroupDataType} from "../models/groups.models";
import {User} from "../models/models";

export const groupsService = {
    fetchGroups: async (page = 0, size = 10, searchValue?: string): Promise<GroupDataType> => {
        const params = new URLSearchParams();

        params.append("page", page.toString());
        params.append("size", size.toString());

        if (searchValue?.trim()) {
            params.append('groupPartName', searchValue.trim());
        }

        const response = await axios.get("/groups", {params});
        return {
            content: (response.data?.content ?? []) as Group[],
            totalElements: response.data.totalElements || 0,
            ...response.data,

        };
    },

    fetchGroupUsers: async (groupId: number): Promise<User[]> => {
        const response = await axios.get(`/groups/${groupId}/users`);
        return response.data;
    },

    createGroup: async (groupName: string): Promise<Group> => {
        const response = await axios.post<Group>("/groups", {groupName});
        return response.data;
    },

    removeGroupById: async (id: number): Promise<void> => {
        return await axios.delete(`/groups/${id}`);
    },

    removeUserFromGroup: async (groupId: number, userId: number): Promise<void> => {
        await axios.delete(`/groups/${groupId}/users/${userId}`);
    },
};